import React, { useState, useEffect, useContext, useRef } from "react";
import "./Header.css";
import { Link, useLocation, useMatch } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faUser } from "@fortawesome/free-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBars, fas, faWallet } from "@fortawesome/free-solid-svg-icons";
import {
  faBell,
  faMagnifyingGlass,
  faShoppingCart,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";

import Cookies from "js-cookie";
import { Context } from "../../utils/context";
import {
  Category,
  PostSearchHistory,
  Products,
} from "../../utils/apis/Product/Product";

import { Webheader, AppSetup } from "../../utils/apis/common/Common";
import { Accordion, ListGroup, Offcanvas } from "react-bootstrap";
import LogoutModal from "../Common_modal/LogoutModal/LogoutModal";
import Permission_Pogout_Modal from "../Common_modal/Permission_Pogout_Modal/Permission_Pogout_Modal";
import Green_Btn from "../Common-Component/common_btn/green_btn/Green_Btn";
import Login_Green_Btn from "../Common-Component/common_btn/login_green_btn/Login_Green_Btn";
import Login_Modal from "../Common_modal/login_modal/Login_Modal";
import Use_Current_Location from "../Common_modal/Use_Current_Location/Use_Current_Location";
import { getLocationFromSession } from "../../utils/apis/location/Location";
import { getNotificationCount } from "../../utils/apis/myAccount/myAccount";

library.add(fas);
const Header = () => {
  // const isVendorPage = useMatch("/vendor-page/:id");
  const location = useLocation();

  // const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(() => {
    return localStorage.getItem("activeItem") || "home";
  });

  useEffect(() => {
    const path = location.pathname.substr(1);
    updateActiveItem(path || "home");
  }, [location]);

  const updateActiveItem = (newActiveItem) => {
    localStorage.setItem("activeItem", newActiveItem);
    setActiveItem(newActiveItem);
  };
  const [activeLink, setActiveLink] = useState("home");
  useEffect(() => {
    getSetup();
    getHeader();
    getCategory();
    const path = location.pathname.substring(1);
    setActiveLink(path || "home");
  }, [location.pathname]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const isActive = (path) => currentPath === path;
  const isActivepath = location.pathname;
  const currentPath = location.pathname;

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/shop", label: "Shop" },
    { path: "/near-me", label: "Near by Store" },
    { path: "/blog", label: "Blogs" },
    { path: "/become-seller", label: "Become Seller" },
    { path: "/contact-us", label: "Contact Us" },
  ];

  const handleMobileLogout = async () => {
    await setSignin(false);
    handleClose();
    setModalShow(true);
    await updateCartCount();
  };

  const handleNavItemClick = (id) => {
    navigate(`/select-from-category/${id}`);
    // setActiveLink(selectedLink);
    // const navbarToggle = document.querySelector(".navbar-toggler");
    // if (navbarToggle && window.innerWidth <= 992) {
    //   navbarToggle.click();
    // }
  };

  const [searchToggled, setIsToggled] = useState(false);
  const searchRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsToggled(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const {
    cartCount,
    signin,
    setSignin,
    wishlistData,
    addCartModal,
    getData,
    updateCartCount,
    wishlistContext,
    setCountNotification,
    countNotification,
    IMG_URL,
    setCurrentLocation,
    currentLocation,
    userdata,
  } = useContext(Context);

  const [category, setCategory] = useState([]);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const getCategory = async () => {
    const res = await Category();
    if (res?.success) {
      setCategory(res.data);
    }
  };
  const [search, setSearch] = useState("");

  const [header, setHeader] = useState([]);
  const getHeader = async () => {
    const res = await Webheader();
    if (res?.success) {
      setHeader(res?.data);
    }
  };

  const [setups, setSetup] = useState();
  const getSetup = async () => {
    const res = await AppSetup();
    if (res?.success) {
      setSetup(res?.data);
    }
  };
  const [modalShow, setModalShow] = useState(false);
  const [modalLocShow, setModalLocShow] = useState(false);
  const [showConfimLocModal, setShowConfimLocModal] = useState(false);

  const navigate = useNavigate();
  const handleLogout = async () => {
    await setSignin(false);
    // Show the modal
    setModalShow(true);
    await updateCartCount();
    await navigate("/");
  };

  const handleNavigate = async (product_id) => {
    localStorage.setItem("product_id", product_id);
    // navigate('/vendor-page');
    window.location.href = `/vendor-page`;
    setIsToggled(false);
  };

  // useEffect(() => {
  //   handleNavigate()
  // }, [product_id]);

  const handleNavClick = (link) => {
    // if (link.path === "/become-seller") {
    //   if (signin) {
    //     Cookies.remove("local_mandai_security", { path: "/" });
    //     // navigate("/login"); old logic
    //     setModalLShow(true);
    //   } else {
    //     navigate("/become-seller");
    //   }
    // } else
    if (
      link.path === "/" ||
      link.path === "/shop" ||
      link.path === "/blog" ||
      link.path === "/near-me" ||
      link.path === "/about-us" ||
      link.path === "/contact-us" ||
      link.path === "/become-seller"
    ) {
      // Normal direct navigation
      navigate(link.path);
    } else {
      // Example: custom category navigation (if needed)
      handleNavItemClick(link.path);
    }

    handleClose();
  };

  const [modalLShow, setModalLShow] = useState(false);
  const [count, setCount] = useState(0);

  const handleCurrentLocation = async () => {
    const res = await getLocationFromSession();
    setCurrentLocation(res);
  };
  useEffect(() => {
    const current_location = Cookies.get("current_location_localmandai");
    if (!current_location) {
      setModalLocShow(true);
    }
    handleCurrentLocation();
  }, []);

  const getcount = async () => {
    const res = await getNotificationCount();
    if (res?.success) {
      setCountNotification(res?.data);
    }
  };

  useEffect(() => {
    getcount();
  }, []);

  const handleSearchClick = async () => {
    if (search.trim() !== "") {
      navigate(`/shop?search=${encodeURIComponent(search)}`);
      if (signin) {
        PostSearchHistory(search, currentLocation?.formatted_address);
      }
    }
  };

  console.log(currentLocation, "currentLocation currentLocation");

  return (
    <>
      <section className="Header">
        <div
          className="top_headers_holder"
          style={{
            backgroundColor: setups?.header_color,
          }}
        >
          <div className="middle_header">
            <div className="container">
              <div className="all_divs_holder">
                <div className="left_side">
                  <div
                    className="logo_div "
                    onClick={() => {
                      navigate("/");
                    }}
                  >
                    <img src={IMG_URL + setups?.image} className="logo_img" />
                  </div>

                  <div className="search_input_div ">
                    <InputGroup className="">
                      <Form.Control
                        placeholder="Search..."
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                      />
                      <InputGroup.Text
                        id="basic-addon2"
                        onClick={handleSearchClick}
                      >
                        <FontAwesomeIcon
                          icon={faMagnifyingGlass}
                          className="search_icon"
                        />
                      </InputGroup.Text>
                    </InputGroup>

                    {/* <ListGroup className="input-group-box">
                      {products?.map((product) => (
                        <ListGroup.Item
                          key={product?.value}
                          onClick={() => handleNavigate(product?.value)}
                        >
                          {product?.label}
                        </ListGroup.Item>
                      ))}
                    </ListGroup> */}
                  </div>
                </div>

                <div className="three_box_div ">
                  {!signin && (
                    <>
                      <div
                        className="box_div address_box"
                        onClick={() => {
                          setModalLocShow(true);
                        }}
                      >
                        <p className="title_text">
                          My Location{" "}
                          <FontAwesomeIcon
                            icon={faSortDown}
                            className="inner_icon"
                          />
                        </p>
                        <p className="sub_text">
                          <span className="title_span address_text">
                            {currentLocation?.formatted_address}
                          </span>
                        </p>
                      </div>
                      <div className="box_div right_box">
                        <div
                          className="header_icon_holder"
                          onClick={() => {
                            navigate("/product-cart");
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faShoppingCart}
                            className={`big_icon `}
                          />
                          <div className="counter_holder">
                            <span className="count_text">{cartCount}</span>
                          </div>
                        </div>

                        <div
                          className="header_icon_holder"
                          onClick={() => {
                            navigate("/wishlist");
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faHeart}
                            className={`big_icon `}
                          />

                          <div className="counter_holder">
                            <span className="count_text">
                              {wishlistData?.length}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="login_btn_holder">
                        <Login_Green_Btn
                          btn_name={"Login"}
                          onClick={() => {
                            setModalLShow(true);
                            setCount((count) => count + 1);
                            // navigate("/login");                                                            old login action
                            // setShowLoginModal(true);                                                        previously commented
                            // setIsLogedIn(true);                                                        previously commented
                          }}
                        />
                      </div>
                    </>
                  )}

                  {signin && (
                    <>
                      <div
                        className="box_div address_box"
                        onClick={() => {
                          setModalLocShow(true);
                        }}
                      >
                        <p className="title_text">
                          My Location{" "}
                          <FontAwesomeIcon
                            icon={faSortDown}
                            className="inner_icon"
                          />
                        </p>
                        <p className="sub_text">
                          <span className="title_span address_text">
                            {currentLocation?.formatted_address}
                          </span>
                        </p>
                      </div>

                      <div className="box_div right_box">
                        <div
                          className="header_icon_holder"
                          onClick={() => {
                            navigate("/product-cart");
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faShoppingCart}
                            className={`big_icon `}
                          />
                          <div className="counter_holder">
                            <span className="count_text">{cartCount}</span>
                          </div>
                        </div>

                        <div
                          className="header_icon_holder"
                          onClick={() => {
                            navigate("/wishlist");
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faHeart}
                            className={`big_icon `}
                          />

                          <div className="counter_holder">
                            <span className="count_text">
                              {wishlistData?.length}
                            </span>
                          </div>
                        </div>

                        <div
                          className="header_icon_holder"
                          onClick={() => {
                            navigate("/wallet-transaction");
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faWallet}
                            className={`big_icon `}
                          />
                        </div>
                        <div
                          className="header_icon_holder bell_icon_holder"
                          onClick={() => {
                            navigate("/notification");
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faBell}
                            className={`big_icon `}
                          />

                          <div className="counter_holder">
                            <span className="count_text">
                              {countNotification?.count}
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bottom_header">
          <div className="container">
            <div className="two_box_holder">
              <div className="box1">
                <div className="category_manu_div"></div>

                <Navbar expand="lg">
                  {/* <div className="category_div">
                    <Category_Dropdown />
                  </div> */}

                  <div className="menu_toggle">
                    <button onClick={handleShow}>
                      <FontAwesomeIcon icon={faBars} className="menu_icon" />
                      MENU
                    </button>
                  </div>

                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                      {navLinks.map((link) => (
                        <Nav.Link
                          key={link.path}
                          as={Link}
                          to={link.path}
                          active={isActive(link.path)}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavClick(link);
                          }}
                        >
                          {link.label}
                        </Nav.Link>
                      ))}

                      {/* <NavDropdown
                        title="All Categories"
                        id="basic-nav-dropdown"
                      >
                        {category?.map((value) => {
                          return (
                            <NavDropdown.Item
                              key={value?.id}
                              onClick={() => navigateToCategory(value?.id)}
                            >
                              {value.name}
                            </NavDropdown.Item>
                          );
                        })}
                      </NavDropdown> */}

                      {/* <Nav.Link
                        as={Link}
                        to="/faq"
                        active={activeItem === "faq"}
                        onClick={handleNavItemClick}
                      >
                        Faqs
                      </Nav.Link> */}
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
              </div>

              <div className="box2">
                <Navbar>
                  <Nav className="me-auto">
                    {signin && (
                      <Nav.Link
                        className="my_acc_nav"
                        as={Link}
                        to={"my-account"}
                      >
                        My Account
                      </Nav.Link>
                    )}
                  </Nav>
                </Navbar>
              </div>
            </div>
          </div>
        </div>

        {/* {isVendorPage && ( */}
        <div className="marque_tag_hodler">
          <div className="marquee_track">
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>

            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>

            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>

            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
          </div>
        </div>
        {/* )} */}
      </section>

      <div className="mobile_header">
        <div className="top_blue_div">
          <div className="d-flex">
            <div
              className="left_menu_icon_div header_icon_holder"
              onClick={handleShow}
            >
              <FontAwesomeIcon icon={faBars} className="big_icon " />
            </div>
            <div
              className="logo_div "
              onClick={() => {
                navigate("/");
              }}
            >
              <img src={IMG_URL + setups?.image} className="logo_img" />
            </div>
          </div>

          <div className="right_side_div">
            <div
              className="header_icon_holder"
              onClick={() => {
                navigate("/product-cart");
              }}
            >
              <FontAwesomeIcon icon={faShoppingCart} className={`big_icon `} />
              <div className="counter_holder">
                <span className="count_text">{cartCount}</span>
              </div>
            </div>

            <div
              className="header_icon_holder"
              onClick={() => {
                navigate("/wishlist");
              }}
            >
              <FontAwesomeIcon icon={faHeart} className={`big_icon `} />

              <div className="counter_holder">
                <span className="count_text">{wishlistData?.length}</span>
              </div>
            </div>

            {/* <div className=" header_icon_holder">
              <FontAwesomeIcon icon={faMagnifyingGlass} className="big_icon " />
            </div> */}

            {signin && (
              <div
                className=" header_icon_holder"
                onClick={() => navigate("/my-account")}
              >
                <FontAwesomeIcon icon={faUser} className="big_icon " />
              </div>
            )}

            {!signin && (
              <div className="mobile_login_btn">
                <Login_Green_Btn
                  btn_name="Login"
                  onClick={() => {
                    setModalLShow(true);
                    setCount((count) => count + 1);
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="mobile_search_input_div ">
          {/* <InputGroup className={showSearchInput ? "show_input" : ""}>
                <Form.Control
                  placeholder="Search..."
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />
                <InputGroup.Text
                  id="basic-addon2 "
                  className="header_icon_holder"
                  onClick={() => {
                    setShowSearchInput(true);
                  }}
                >
                  <FontAwesomeIcon
                    onClick={handleSearchClick}
                    icon={faMagnifyingGlass}
                    className="big_icon"
                  />
                </InputGroup.Text>
              </InputGroup> */}

          <div className="search_input_div ">
            <InputGroup className="">
              <Form.Control
                placeholder="Search..."
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
              <InputGroup.Text id="basic-addon2" onClick={handleSearchClick}>
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="search_icon"
                />
              </InputGroup.Text>
            </InputGroup>

            {/* <ListGroup className="input-group-box">
                      {products?.map((product) => (
                        <ListGroup.Item
                          key={product?.value}
                          onClick={() => handleNavigate(product?.value)}
                        >
                          {product?.label}
                        </ListGroup.Item>
                      ))}
                    </ListGroup> */}
          </div>

          <ListGroup className="input-group-box">
            {/* {products.map((product) => (
                  <ListGroup.Item
                    key={product?.value}
                    onClick={() => handleNavigate(product?.value)}
                  >
                    {product?.label}
                  </ListGroup.Item>
                ))} */}
          </ListGroup>
        </div>

        {/* {isVendorPage && ( */}
        <div className="marque_tag_hodler">
          <div className="marquee_track">
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>

            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>

            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>

            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
            <span className="marquee_text">
              Share Product To Earn Money When The Purchase
            </span>
          </div>
        </div>
        {/* )} */}

        <div className="address_content">
          <img
            src="/assets/Image/header/location.png"
            className="location_img"
          />
          <p className="location_text">{currentLocation?.formatted_address}</p>
        </div>

        <Offcanvas
          show={show}
          onHide={handleClose}
          className="mobile_menu_offcanvas"
        >
          <Offcanvas.Header>
            <Offcanvas.Title>
              <div className="close_img_div" onClick={handleClose}>
                <img
                  src="/assets/Image/header/close.png"
                  className="close_img"
                />

                <div
                  className="logo_div "
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <img src={IMG_URL + setups?.image} className="logo_img" />
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Navbar expand="lg" className="header_navbar">
              <Nav>
                {navLinks.map((link) => (
                  <Nav.Link
                    key={link.path}
                    // as={Link}
                    // to={link.path}
                    active={isActive(link.path)}
                    onClick={() => handleNavClick(link)}
                  >
                    {link.label}
                  </Nav.Link>
                ))}

                {/* <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>All Categories</Accordion.Header>
                    <Accordion.Body>
                      {category?.map((value) => {
                        return (
                          <NavDropdown.Item
                            key={value?.id}
                            onClick={() => navigateToCategory(value?.id)}
                          >
                            <span
                              onClick={() => {
                                handleNavItemClick();
                                setShowOffcanvas(false);
                              }}
                            >
                              {value.name}
                            </span>
                          </NavDropdown.Item>
                        );
                      })}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Nav.Link
                  as={Link}
                  to="/faq"
                  active={activeItem === "faq"}
                  onClick={handleClose}
                >
                  Faqs
                </Nav.Link> */}

                {signin && (
                  <Nav.Link as={Link} onClick={handleMobileLogout}>
                    Log Out
                  </Nav.Link>
                )}
              </Nav>
            </Navbar>
          </Offcanvas.Body>
        </Offcanvas>
      </div>

      <Login_Modal
        key={count}
        show={modalLShow}
        onHide={() => setModalLShow(false)}
      />

      <Use_Current_Location
        show={modalLocShow}
        onHide={() => setModalLocShow(false)}
        setShowConfimLocModal={setShowConfimLocModal}
      />

      <Permission_Pogout_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      {/* old header */}

      {/* <section
        className="second-header-sec"
        style={{
          backgroundColor: setups?.header_color,
        }}
      >
        <div className="desktop_view_header">
          <div className="container-xl">
            <Navbar expand="md">
              <Navbar.Brand as={Link} to="/" className="order-lg-1 order-2">
                <img
                  className="headlogo"
                  src={IMG_URL + setups?.image}
                  alt="Logo"
                />
              </Navbar.Brand>

              <Navbar.Collapse
                id="basic-navbar-nav "
                className="d-none d-lg-block order-lg-2 order-2
            "
              >
                <Nav className="mx-auto">
                  <Nav.Link
                    as={Link}
                    to="/"
                    active={activeItem === "home"}
                    onClick={handleNavItemClick}
                  >
                    Home
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/near-me"
                    active={activeItem === "near-me"}
                    onClick={handleNavItemClick}
                  >
                    Near Me
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    active={activeItem === "about-us"}
                    onClick={handleNavItemClick}
                  >
                    About Us
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/contact-us"
                    active={activeItem === "contact-us"}
                    onClick={handleNavItemClick}
                  >
                    Contact Us
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/blog"
                    active={activeItem === "blog"}
                    onClick={handleNavItemClick}
                  >
                    Blog
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to={signin ? "/login" : "/become-seller"}
                    active={activeItem === "become-seller"}
                    onClick={() => {
                      if (signin) {
                        Cookies.remove("local_mandai_security", { path: "/" });
                        window.location.href = "/login";
                      } else {
                        window.location.href = "/become-seller";
                      }
                      handleNavItemClick();
                    }}
                  >
                    Become a Seller
                  </Nav.Link>

                  <NavDropdown
                    title="All Categories"
                    id="basic-nav-dropdown"
                    className="me-3"
                  >
                    {category?.map((value) => {
                      return (
                        <NavDropdown.Item
                          key={value?.id}
                          onClick={() => navigateToCategory(value?.id)}
                        >
                          {value.name}
                        </NavDropdown.Item>
                      );
                    })}
                  </NavDropdown>
                  <Nav.Link
                    as={Link}
                    to="/faq"
                    active={activeItem === "faq"}
                    onClick={handleNavItemClick}
                  >
                    FAQs
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>

              <div className="all-icon ms-auto mt-lg-0 mt-md-3 mt-sm-3 mt-3 order-lg-3 order-3">
                {signin && (
                  <FontAwesomeIcon
                    onClick={() => {
                      navigate(`/wallet-transaction`);
                    }}
                    icon={faWallet}
                    className="cart-logo"
                  />
                )}

                <FontAwesomeIcon
                  icon="fa-solid fa-magnifying-glass"
                  className="cart-logo"
                  onClick={toggleClick}
                />

                <Link className="cart-icon-holder" to={"/product-cart"}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-cart-shopping"
                    className="cart-logo r"
                    onClick={handleNavItemClick}
                  />
                  <span className="count-span-holder">{cartCount}</span>
                </Link>

                {signin ? (
                  <>
                    {wishlistData?.length > 0 ? (
                      <Link to={"/wishlist"}>
                        <FontAwesomeIcon
                          icon={faHeart}
                          className="cart-logo"
                          onClick={handleNavItemClick}
                        />
                      </Link>
                    ) : (
                      <Link to={"/empty-wislist"}>
                        <FontAwesomeIcon
                          icon={faHeart}
                          className="cart-logo"
                          onClick={handleNavItemClick}
                        />
                      </Link>
                    )}

                    <Link to={"/my-account"}>
                      <FontAwesomeIcon
                        icon="fa-solid fa-user"
                        className="cart-logo"
                        onClick={handleNavItemClick}
                      />
                    </Link>
                    <Link className="login" onClick={handleLogout}>
                      Logout
                    </Link>
                  </>
                ) : (
                  <>
                    <Link to={"/empty-wislist"}>
                      <FontAwesomeIcon
                        icon={faHeart}
                        className="cart-logo "
                        onClick={handleNavItemClick}
                      />
                    </Link>
                    <Link to={"/login"} className=" login">
                      Login
                    </Link>
                  </>
                )}

                {searchToggled && (
                  <div ref={searchRef} className="input-group-box mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Search here"
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                    />

                    <ListGroup>
                      {products.map((product) => (
                        <ListGroup.Item
                          key={product?.value}
                          onClick={() => handleNavigate(product?.value)}
                        >
                          {product?.label}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>
                )}
              </div>
            </Navbar>
          </div>
        </div>

        <Offcanvas
          show={showOffcanvas}
          className="secondHeaderOffcanvas d-block d-lg-none"
          onHide={() => setShowOffcanvas(false)}
          placement="start"
        >
          <Offcanvas.Header closeButton>
            <div className="logo_holder">
              <img
                className="headlogo"
                src={IMG_URL + setups?.image}
                alt="Logo"
              />
            </div>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="flex-column">
              <Nav.Link
                as={Link}
                to="/"
                active={activeItem === "home"}
                onClick={() => {
                  handleNavItemClick();
                  setShowOffcanvas(false);
                }}
              >
                Home
              </Nav.Link>

              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>All Categories</Accordion.Header>
                  <Accordion.Body>
                    {category?.map((value) => {
                      return (
                        <NavDropdown.Item
                          key={value?.id}
                          onClick={() => navigateToCategory(value?.id)}
                        >
                          <span
                            onClick={() => {
                              handleNavItemClick();
                              setShowOffcanvas(false);
                            }}
                          >
                            {value.name}
                          </span>
                        </NavDropdown.Item>
                      );
                    })}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <Nav.Link
                as={Link}
                to="/near-me"
                active={activeItem === "near-me"}
                onClick={() => {
                  handleNavItemClick();
                  setShowOffcanvas(false);
                }}
              >
                Near Me
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/about-us"
                active={activeItem === "about-us"}
                onClick={() => {
                  handleNavItemClick();
                  setShowOffcanvas(false);
                }}
              >
                About Us
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/contact-us"
                active={activeItem === "contact-us"}
                onClick={() => {
                  handleNavItemClick();
                  setShowOffcanvas(false);
                }}
              >
                Contact Us
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/blog"
                active={activeItem === "blog"}
                onClick={() => {
                  handleNavItemClick();
                  setShowOffcanvas(false);
                }}
              >
                Blog
              </Nav.Link>
              <Nav.Link
                as={Link}
                to={signin ? "/login" : "/become-seller"}
                active={activeItem === "become-seller"}
                onClick={() => {
                  if (signin) {
                    Cookies.remove("local_mandai_security", { path: "/" });
                    window.location.href = "/login";
                  } else {
                    window.location.href = "/become-seller";
                  }
                  handleNavItemClick();
                  setShowOffcanvas(false);
                }}
              >
                Become a Seller
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/faq"
                active={activeItem === "faq"}
                onClick={() => {
                  handleNavItemClick();
                  setShowOffcanvas(false);
                }}
              >
                FAQs
              </Nav.Link>
            </Nav>
          </Offcanvas.Body>
        </Offcanvas>

        <div className="mobile_view_header">
          <Container>
            <Navbar expand="lg">
              <div className="top_content d-flex justify-content-between">
                <Navbar.Brand as={Link} to="/" className="order-lg-1 order-2">
                  <img
                    className="headlogo"
                    src={IMG_URL + setups?.image}
                    alt="Logo"
                  />
                </Navbar.Brand>

                <div className="all-icon ms-auto mt-lg-0 mt-md-3 mt-sm-3 mt-3 order-lg-3 order-3">
                  <Link className="cart-icon-holder" to={"/product-cart"}>
                    <FontAwesomeIcon
                      icon="fa-solid fa-cart-shopping"
                      className="cart-logo r"
                      onClick={handleNavItemClick}
                    />
                    <span className="count-span-holder">{cartCount}</span>
                  </Link>
                  {signin && (
                    <FontAwesomeIcon
                      onClick={() => {
                        navigate(`/wallet-transaction`);
                      }}
                      icon={faWallet}
                      className="cart-logo"
                    />
                  )}

                  {signin ? (
                    <>
                      {wishlistData?.length > 0 ? (
                        <Link to={"/wishlist"}>
                          <FontAwesomeIcon
                            icon={faHeart}
                            className="cart-logo"
                            onClick={handleNavItemClick}
                          />
                        </Link>
                      ) : (
                        <Link to={"/empty-wislist"}>
                          <FontAwesomeIcon
                            icon={faHeart}
                            className="cart-logo"
                            onClick={handleNavItemClick}
                          />
                        </Link>
                      )}

                      <Link to={"/my-account"}>
                        <FontAwesomeIcon
                          icon="fa-solid fa-user"
                          className="cart-logo"
                          onClick={handleNavItemClick}
                        />
                      </Link>
                      <Link className="login" onClick={handleLogout}>
                        Logout
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link to={"/empty-wislist"}>
                        <FontAwesomeIcon
                          icon={faHeart}
                          className="cart-logo "
                          onClick={handleNavItemClick}
                        />
                      </Link>
                      <Link to={"/login"} className=" login">
                        Login
                      </Link>
                    </>
                  )}
                </div>
              </div>

              <div className="bottom_content">
                <div className="menu_icon_div">
                  <FontAwesomeIcon
                    icon={faBars}
                    className="menu_icon"
                    aria-controls="offcanvasNavbar order-lg-4 order-1"
                    onClick={() => setShowOffcanvas(true)}
                  />
                </div>

                <div ref={searchRef} className="input-group-box mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Search here"
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />

                  <ListGroup>
                    {products.map((product) => (
                      <ListGroup.Item
                        key={product?.value}
                        onClick={() => handleNavigate(product?.value)}
                      >
                        {product?.label}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
              </div>
            </Navbar>
          </Container>
        </div>
      </section> */}
    </>
  );
};

export default Header;
